// Activity options found here https://learn.microsoft.com/en-us/microsoftteams/presence-admins
export enum Availability {
    AVAILABLE = 'Available',
    BUSY = 'Busy',
    AWAY = 'Away',
    DO_NOT_DISTURB = 'DoNotDisturb',
    BE_RIGHT_BACK = 'BeRightBack',
    OUT_OF_OFFICE = 'OutOfOffice',
    OFFLINE = 'Offline'
}

export enum PresenceFilter {
    AVAILABILITY = 'availability',
    DEPARTMENT = 'department',
    QUEUE = 'queue'
}

export enum SortingOptions {
    ASC = 'asc',
    DESC = 'desc'
}

export const getEnabledAvailabilities = (enabledOutOfOffice: boolean): Availability[] =>
    enabledOutOfOffice
        ? Object.values(Availability)
        : Object.values(Availability).filter(
              (availability: Availability): boolean => availability !== Availability.OUT_OF_OFFICE
          )

export const DARK_MODE_LOCAL_STORAGE_KEY: string = 'darkMode'
export const PRESENCE_FILTERS_LOCAL_STORAGE_KEY: string = 'presenceFilters'
export const PRESENCE_FILTERS_SORT_BY_LOCAL_STORAGE_KEY: string = 'presenceFiltersSortBy'

export const DEFAULT_PRESENCE_LIMIT: number = 100

export const MAX_SEARCH_QUERY_LENGTH: number = 30
